import { mapGetters, mapActions } from 'vuex';
import { objectIsDefinedAndHasProperty } from '@/composables/is-defined';

export default {
	data() {
		return {
			reponsibleForUserInfo: true
		};
	},
	async created() {
		if (
			this.reponsibleForUserInfo &&
			!objectIsDefinedAndHasProperty(this.userInfo, 'sub')
		) {
			await this.getUserInfoAction();
		}
	},
	computed: {
		...mapGetters('user', [
			'userInfo',
			'userToken',
			'userReady',
			'initialized'
		])
	},
	methods: {
		...mapActions('user', ['getUserInfoAction', 'setTokenAction'])
	}
};
